import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CHECKOUT_URL } from '../data/content';

/**
 * Sticky checkout bar that appears once the first CTA has been passed.
 * Anchored to the element with id="cta-anchor".
 */
export function FloatingCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const anchor = document.getElementById('cta-anchor');
    if (!anchor) return;
    const observer = new IntersectionObserver(([entry]) => {
      setVisible(entry.boundingClientRect.top < 0 && !entry.isIntersecting);
    }, {
      threshold: 0
    });
    observer.observe(anchor);
    return () => observer.disconnect();
  }, []);
  return <AnimatePresence data-id="element-126" data-mp="bpre5fu8k5lz">
      {visible && <motion.div initial={{
      y: 90,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 90,
      opacity: 0
    }} transition={{
      duration: 0.26,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-50 px-3 pb-3 pt-2" data-id="element-127" data-mp="boydmwlvecca">
          <div className="mx-auto max-w-xl rounded-2xl border border-gold/40 bg-ink/95 p-2.5 shadow-float backdrop-blur" data-id="element-128" data-mp="2b4jvbkajs4m2">
            <div className="flex items-center gap-3" data-id="element-129" data-mp="21cnif33sy9xs">
              <div className="hidden shrink-0 pl-2 sm:block" data-id="element-130" data-mp="21c4dcmz93g16">
                <p className="font-display text-lg font-bold leading-none text-cream" data-id="element-131" data-mp="26b75x7y1nts9">$27</p>
                <p className="text-[10px] uppercase tracking-[0.14em] text-gold-light" data-id="element-132" data-mp="1req00w8mj7d3">One-time</p>
              </div>
              <a href={CHECKOUT_URL} rel="noopener" className="flex-1 animate-shake rounded-xl bg-gold px-4 py-3.5 text-center text-[14px] font-extrabold uppercase tracking-[0.05em] text-ink transition-[background-color,transform] duration-150 ease-out hover:bg-gold-light active:scale-[0.98] sm:text-[15px]" data-id="element-133" data-mp="1wdt1k6peavgb">
                Get Resin Architect™ · $27
              </a>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}